var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", { attrs: { "no-padding": "", title: _vm.title } }),
      _vm._v(" "),
      _vm.isLoading
        ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.isValid
        ? _c("data-set-metadata-schema-detail-form", {
            attrs: { schema: _vm.schema },
            on: {
              change: _vm.onFormChange,
              submit: _vm.onFormSubmit,
              close: _vm.onFormClose,
              delete: _vm.onFormDelete,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("v-card", { attrs: { color: "grey lighten-4" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }